import { render, staticRenderFns } from "./ShowCode.vue?vue&type=template&id=8e64bcd2&"
import script from "./ShowCode.vue?vue&type=script&lang=js&"
export * from "./ShowCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports